import React, { PureComponent } from 'react';
import { DLSelect } from 'appSrc/components/UI';

export default class FormSelect extends PureComponent {
    onChange = ( e, data ) => {
        this.props.input.onChange( data.value );
    }
    render() {
        const { input: { name, onFocus, onBlur }, meta: { error, touched }, multiple } = this.props;
        var value = this.props.input.value;
        if( multiple ) {
            value = value || [];
        }
        var props = {
            ...this.props,
            value,
            name,
            multiple,
            onChange: this.onChange,
            onFocus,
            onBlur,
            error: touched ? error : undefined,
        };

        return (
            <DLSelect { ...props } />
        );
    }
}

FormSelect.defaultProps = {
    className: '',
    style: {},
};
